import { render, staticRenderFns } from "./DetailPlayer.vue?vue&type=template&id=7101d446&scoped=true"
import script from "./DetailPlayer.vue?vue&type=script&lang=js"
export * from "./DetailPlayer.vue?vue&type=script&lang=js"
import style0 from "./DetailPlayer.vue?vue&type=style&index=0&id=7101d446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7101d446",
  null
  
)

export default component.exports